// extracted by mini-css-extract-plugin
export default {"filter":"auction_filter__OI1RG","title":"auction_title__HuaCA","title2":"auction_title2__6jvgk"};